import { Global } from "../service/global";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export class DisplayOnScroll
{
	protected $root: JQuery;
    protected st:any;

	constructor(elem: HTMLElement)
    {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI = () => {

        // @ts-ignore
        gsap.registerPlugin(ScrollTrigger);
        
        if (typeof this.st != 'undefined') {
            this.st.kill();
        }

        this.st = ScrollTrigger.create({
          trigger: this.$root.get(0),
          start: 'top ' + this.setTiggerPoint() + '%',
          toggleClass: 'dsp-triggered',
          once: true
        });
    }

    private setTiggerPoint = ():string => {
        return (Global.getViewport().height >= 800) ? '80': '88';
    }
}